import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ConvertLeadSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState();

  const gotoLeads = () => {
    navigate('/leads');
  };

  useEffect(() => {
    if (location.pathname.includes('convertLead') && location.state) {
      let updatedFormData = {
        ...location.state,
        name: location.state.companyName,
        type: 'convert',
      };
      setFormData(updatedFormData);
    }
  }, [location]);

  useEffect(() => {
    // Push a dummy entry to intercept back button
    window.history.pushState(null, '', window.location.href);

    const onPopState = () => {
      // User clicked back, redirect them wherever you want
      navigate('/leads'); // 👈 Your custom redirect
    };

    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [navigate]);

  return (
    <div className="convert_container" id="convertlead">
      <div className="row">
        <div className="col-12 col-md-12">
          <div className="input-container">
            <label htmlFor="timeZoneId" style={{ fontSize: '1rem' }}>
              {' '}
              The Lead {formData?.firstName} {formData?.lastName} has been successfully converted.
            </label>
          </div>
        </div>
        <div className="col-12 col-md-12">
          <div className="input-container">
            <label htmlFor="timeZoneId" style={{ fontSize: '1rem' }}>
              Conversion Details
            </label>
          </div>
        </div>
        <div className="col-12 col-md-3" id="convrtlead">
          <div className="input-container">
            <label htmlFor="timeZoneId">Account</label>
            <label className="notetxt">{formData?.companyName}</label>
          </div>
        </div>
        <div className="col-12 col-md-3" id="convrtlead">
          <div className="input-container">
            <label htmlFor="timeZoneId">Create New Contact </label>
            <label className="notetxt">
              {formData?.firstName} {formData?.middleName} {formData?.lastName}
            </label>
          </div>
        </div>
        <div className="col-12 col-md-12">
          <hr />
        </div>
        <div className="col-12 col-md-12">
          <div className="input-container">
            <div className="convert_group">
              <button type="button" className="btn btn-primary" onClick={gotoLeads}>
                Go To Leads
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvertLeadSuccess;
